import Skeleton from 'react-loading-skeleton';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const CSkeleton = styled(Skeleton)`
  --base-color: ${({ theme }) => theme.colors.skeletonBase};
  --highlight-color: ${({ theme }) => theme.colors.skeletonHighlight};
  cursor: default;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  opacity: 0;
  animation: ${fadeIn} 0.5s forwards 0.3s;
`;

export const AssessmentCardSkeleton = styled(CSkeleton)`
  height: 252px;
`;

export const ButtonSkeleton = styled(CSkeleton)`
  height: 48px;
  width: 150px;
`;

export const ThreeColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 3px;
`;

export const TimelineWrap = styled.div`
  max-width: 500px;
`;

export const ButtonsRowEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-gap: 10px;
`;

export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 10px 1fr;
  grid-gap: 10px;
`;

export const CommentColumn = styled.div`
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const OrgHeaderRow = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 30px;
`;
